export default __webpack_public_path__ + "static/media/nyc.3caba30f.png";